/**
 * src/lib/lienKetChu.js — liên kết viết ngay trong câu chữ của nội dung tĩnh.
 *
 * Cú pháp: [[slug]] hoặc [[slug|chữ hiển thị]] dẫn tới /thuat-ngu/slug;
 * [[/duong-dan|chữ hiển thị]] dẫn tới một trang bất kỳ trong site.
 *
 * Vì sao cần: trang từ điển chỉ có chữ thuần thì Google không thấy các trang
 * liên quan nối với nhau, và người đọc gặp một thuật ngữ lạ cũng không bấm
 * sang được. Liên kết nội bộ giúp cả hai.
 *
 * File này không phụ thuộc React để seo.js và các script build dùng được.
 */

const MAU = /\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g;

/** Tách chuỗi thành các mảnh chữ và mảnh liên kết. */
export function tachLienKet(chuoi) {
  const ra = [];
  let viTri = 0;
  for (const m of String(chuoi).matchAll(MAU)) {
    if (m.index > viTri) ra.push({ chu: chuoi.slice(viTri, m.index) });
    const dich = m[1].trim();
    const href = dich.startsWith('/') ? dich : `/thuat-ngu/${dich}`;
    ra.push({ chu: (m[2] || '').trim(), href, slug: dich.startsWith('/') ? null : dich });
    viTri = m.index + m[0].length;
  }
  if (viTri < String(chuoi).length) ra.push({ chu: String(chuoi).slice(viTri) });
  return ra;
}

/**
 * Bỏ cú pháp liên kết, giữ chữ. Dùng cho thẻ meta, JSON-LD, đoạn trích.
 * [[slug]] không ghi chữ hiển thị thì lấy tên thuật ngữ qua `tenTheoSlug`.
 */
export function boLienKet(chuoi, tenTheoSlug = () => '') {
  return tachLienKet(chuoi)
    .map((m) => (m.href ? m.chu || tenTheoSlug(m.slug) || m.slug || '' : m.chu))
    .join('');
}

/** Mọi đích liên kết trong một chuỗi, để kiểm tra không có link chết. */
export function dichLienKet(chuoi) {
  return tachLienKet(chuoi).filter((m) => m.href).map((m) => m.href);
}
